




















































import { defineComponent } from '@vue/composition-api';
import { usersHeadersData } from '@/bundles/Users/helpers';
import moment from 'moment';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { useTable } from '@/bundles/BaseTable/composables/useTable';

import BaseTable from '@/bundles/BaseTable/components/BaseTable.vue';

export default defineComponent({
  name: 'UsersListTable',

  components: {
    BaseTable,
  },

  emits: ['options:change'],

  props: {
    tableOptionsEntry: {
      type: Object,
      required: true,
    },
    itemsEntry: {
      type: Array,
      default: () => [],
    },
    totalRowsEntry: {
      type: Number,
      default: 0,
    },
    loading: Boolean,
  },

  setup: function (props, { emit }) {
    const { calculateHeight } = useTable();

    function optionsChangeEventHandler(options: ITableOptions) {
      emit('options:change', options);
    }

    function formatDate(date: string): string {
      if (!date) return '';
      return `${ moment(date).format('M/D/YYYY') } - ${ moment(date).isBefore(Date.now()) ? 'expired' : 'active' }`;
    }

    // TODO: prepare correct type
    function getUserDevices (user: any) {
      let devices: string[] = [];
      if (user.subscription && user.subscription.type !== 'custom') {
        const device = user.subscription.type === 'apple' ? 'ios' : 'android';
        devices.push(device);
      }
      if (user.device_token) {
        const tokenDevices = user.device_token.tokens?.map((info: any) => info.platform) || [];
        devices = devices.concat(tokenDevices);
      }
      return [...new Set(devices)];
    }

    return {
      usersHeadersData,
      calculateHeight,
      optionsChangeEventHandler,
      formatDate,
      getUserDevices,
    };
  },
});
